import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './ToolProjectType.css';
import {
  setProjectType,
  selectProjectType,
} from '../../../redux/projectTypeSlice';
import {
  PROJECT_TYPES,
  PROJECT_TYPE_LABELS,
} from '../../../constants/projectTypes';
import DocumentsPopup from './DocumentsPopup';

const ToolProjectType = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDocumentsPopupOpen, setIsDocumentsPopupOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const dropdownRef = useRef(null);
  const selectTriggerRef = useRef(null);

  const dispatch = useDispatch();
  const projectType = useSelector(selectProjectType);

  // Click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleProjectTypeChange = (type) => {
    dispatch(setProjectType(type));
    setShowDropdown(false);
  };

  const projectTypeOptions = Object.entries(PROJECT_TYPES).map(([key, value]) => ({
    value,
    label: PROJECT_TYPE_LABELS[value],
  }));

  return (
    <div className={`toolProjectTypeAccordion ${isOpen ? 'open' : 'closed'}`}>
      {isOpen && (
        <div className="toolProjectType-content">
          {/* Proje Tipi Select */}
          <div className="projectType-selector" ref={dropdownRef}>
            <div
              className="projectType-select"
              ref={selectTriggerRef}
              onClick={() => {
                if (!showDropdown && selectTriggerRef.current) {
                  const rect = selectTriggerRef.current.getBoundingClientRect();
                  setDropdownPos({ top: rect.bottom + 2, left: rect.left, width: rect.width });
                }
                setShowDropdown(!showDropdown);
              }}
            >
              <span className="projectType-label">
                {PROJECT_TYPE_LABELS[projectType]}
              </span>
              <span className="projectType-arrow">{showDropdown ? '▲' : '▼'}</span>
            </div>

            {showDropdown && (
              <div className="projectType-dropdown" style={{ top: dropdownPos.top, left: dropdownPos.left, minWidth: dropdownPos.width }}>
                {/* Project Type Options */}
                {projectTypeOptions.map((option) => (
                  <div
                    key={option.value}
                    className={`projectType-option ${projectType === option.value ? 'selected' : ''}`}
                    onClick={() => handleProjectTypeChange(option.value)}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Dokümanlar Button */}
          <button
            className="documents-button"
            onClick={() => setIsDocumentsPopupOpen(true)}
            title="Proje Dokümanları"
          >
            Dokümanlar
          </button>
        </div>
      )}

      {/* Toggle Button */}
      <div className="toolProjectType-toggle">
        <button
          className="toolButton toggleArrowButton"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? '◀' : 'Detay▶'}
        </button>
      </div>

      {/* Documents Popup */}
      <DocumentsPopup
        isOpen={isDocumentsPopupOpen}
        onClose={() => setIsDocumentsPopupOpen(false)}
      />
    </div>
  );
};

export default ToolProjectType;
